import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'


export class AccountBonuses extends React.Component {


    constructor(props) {
        super(props);

        this.redirectDone = true;
        this.state = {
            redirectTo: '/',
            redirectToState: {},
            promotions: null,
            activePokerReloadPromotion: null,
            disableBtn: false,
            selectedPromotion: null,
            games: null,
            couponCode: "",
            couponCodeStatus: 1,  //1 - default, 2 - code entered in text box, 3 - submitting, 4 - server return code not found, 5 - server return code already used,
            fromSport: false
        }

        this.props.fetchUserFn();
        this.showUser = this.showUser.bind(this);
        this.doRedirect = this.doRedirect.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.prihvatiBonus = this.prihvatiBonus.bind(this);
        this.showPopUp = this.showPopUp.bind(this);
        this.submitCoupon = this.submitCoupon.bind(this);
        this.setCouponCode = this.setCouponCode.bind(this);
        this.fetchData();
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Bonusi', 'casino', this.props.user);

        this.promoIdAccounts = [245299, 225382, 218661, 210265, 280867];
    }

    componentDidMount() {
        const sportParam = new URLSearchParams(location.search).get("fromsport");
        if (sportParam && sportParam == "1") {
            this.setState({ fromSport: true });
        }

        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    showUser(user, sesijaId) {
        this.props.updateUserFn(user, sesijaId);
    }

    fetchData() {
        var promises = Promise.all([casino.repos.promotionRepo.list(), casino.repos.gameRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }


    doRedirect(path, state) {
        this.redirectDone = false;
        this.setState({
            redirectTo: path,
            redirectToState: state
        });
    }

    setData(data) {
        var promotions = data[0];
        var games = data[1].items;
        let activePokerReloadPromotion = false;
        let runningPokerReloadPromotion = false;
        if (promotions && promotions.availableItems)
            promotions.availableItems.map(x => {
                if (x.poker)
                    activePokerReloadPromotion = true;
            })

        if (promotions && promotions.runningItems)
            promotions.runningItems.map(x => {
                if (x.poker)
                    runningPokerReloadPromotion = true;
            })


        this.setState({
            promotions: promotions,
            samoZaMene: promotions.samoZaMene,
            samoZaMeneVrijediDo: promotions.ponudaVrijediDo,
            archive: promotions.archive,
            activePokerReloadPromotion: activePokerReloadPromotion,
            runningPokerReloadPromotion: runningPokerReloadPromotion,
            games: games
        });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
    }

    prihvatiBonus(promocija) {
        this.setState({ disableBtn: true });
        this.props.disablePopUpBtnFn(true);
        this.props.showLoadingFn(true);
        this.props.showPopUpFn(false);
        this.props.showLoadingFn(false);
        this.props.disablePopUpBtnFn(false);
        this.setState({ disableBtn: false });
        casino.repos.promotionRepo.create(promocija)
            .then((response) => { return response.json(); })
            .then((data) => {

                if (data != null) {
                    this.props.showPopUpFn(true, "prihvatiSamoZaMeneBonus", () => this.onPrihvacenaPonudeRedirect(promocija), promocija);
                } else {
                    this.props.showPopUpFn(true, "ponudaNijeAkrivirana", null, null);
                }
            });
    }

    onPrihvacenaPonudeRedirect(promocija) {
        this.props.showPopUpFn(false);
        this.props.showLoadingFn(false);
        this.props.disablePopUpBtnFn(false);
        this.setState({ disableBtn: false });
        var sifraMobile = promocija?.sifraMobile;
        if (promocija?.sifreIgara != null && promocija.sifreIgara.length == 1) {
            sifraMobile = promocija.sifreIgara[0];
        }

        if (sifraMobile && this.props.brands && this.state.games) {
            var game = this.state.games.find(game => game.s === sifraMobile);
            if (casino.config.fromNativeApp) {
                window.location.replace(`supersport://casino/games/${game.s}`)
            }
            else {

                this.doRedirect(this.props.getHomePathFn(this.props.route.location) + "game/" + this.props.brands[game.bID].nameNormalizirano + "/" + casino.utils.normalizeString(game.n), null);
            }
        }
        else if (promocija.brandID) {
            window.location.href = "provideri?provider=" + this.props.brands[promocija.brandID].nameNormalizirano
        }
        else {
            this.doRedirect('/account', null);
        }
    }

    postojeAktivnePromocije() {
        return this.props.user.promocije.runningItems.some(it => it.active) || this.props.user.promocije.availableItems.length > 0;
    }

    showPopUp(x) {
        if (this.postojeAktivnePromocije()) {
            this.props.showPopUpFn(true, "infoAktivanBonus");
        } else {
            var game = this.state.games.find(game => game.s === x.sifraMobile)
            var jeOdrzavanje = game && game?.p && game.p.indexOf("o") != -1 ? true : false;
            if (jeOdrzavanje) {
                this.props.showPopUpFn(true, "igraNaOdrzavanju");

            } else {
                this.prihvatiBonus(x);
            }
        }
    }

    selectPromotion(promotion) {
        this.setState({ selectedPromotion: promotion });
    }

    submitCoupon() {
        this.setState({ couponCodeStatus: 3 });
        casino.repos.casinoBonusCodeRepo.post(this.state.couponCode).then((response) => {
            if (response == -1) {
                this.setState({ couponCodeStatus: 5 });
            } else if (response == 0) {
                this.setState({ couponCodeStatus: 4 });
            } else {
                this.props.showPopUpFn(true, "coupon-activated", null, { code: this.state.couponCode });
                this.setState({ couponCodeStatus: 1, couponCode: "" });
                this.props.fetchUserFn();
                this.fetchData();
            }
        });
    }

    setCouponCode(value) {
        this.setState({ couponCode: value }, () => {
            this.setState({ couponCodeStatus: this.state.couponCode.length > 1 ? 2 : 1 });
        });
    }

    renderKuponiSection() {
        return <section>
            <div className="aktivnaPonudaSection">
                <h3>Imaš promo kod?</h3>
                <div className="coupon-container">
                    <span className={"input-container" + (this.state.couponCodeStatus == 2 ? " success" : this.state.couponCodeStatus == 4 ? " error" : "")}>
                        <input className="coupon-input" type="text" placeholder="Upiši kod"
                            maxLength={32}
                            value={this.state.couponCode}
                            onChange={event => this.setCouponCode(event.target.value)} />
                        <span className="coupon-status"></span>
                    </span>
                    <button className="coupon-btn" onClick={this.submitCoupon} disabled={this.state.couponCodeStatus == 1 || this.state.couponCodeStatus == 3}>Aktiviraj</button>
                </div>
                {this.state.couponCodeStatus == 4 && <div className="coupon-error">Pogrešan kod!</div>}
                {this.state.couponCodeStatus == 5 && <div className="coupon-error">Kod je već iskorišten!</div>}
                <p className="coupon-info">
                    Upiši promo kod i aktiviraj bonus ponudu. Stanja bonusa možeš vidjeti pod tvojim bonusima.
                </p>
            </div>
        </section>
    }

    render() {
        var pathName = this.props.route.match.url;
        var user = this.props.user;
        var aktivniBonus = user && user.promocije.runningItems.length > 0 && user.promocije.runningItems[user.promocije.runningItems.length - 1];
        let activePokerReloadPromotion = this.props.promotions && this.props.activePokerReloadPromotion;



        if (this.props.user) {
            return <div>
                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}

                <MetaTags title="Moji bonusi | SuperSport Casino" description={" "} />
                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText={"Bonusi"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />
                <div className="flex margin-1p-on-tablet">
                    {!this.state.fromSport && <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>}
                    <div id="page-wrapper" className="flex-expand-1 no-padding" >

                        {this.props.user && this.promoIdAccounts.includes(this.props.user.igracID) && this.renderKuponiSection()}

                        {/*****************------------MOJA AKTIVNA PONUDA-------------******************/}

                        <section>
                            {this.props.user && !!this.props.user.promocije.availableItems.length && this.props.user.promocije.availableItems.map(x => {
                                return <div className="aktivnaPonudaSection" key={x.id} >
                                    <h3>Moja aktivna ponuda</h3>
                                    <div className="aktivnaPonudaContainer">
                                        <div className="aktivnaPonudaLeft">
                                            {x.poker ? < div className="aktivnaPonudaIcon poker">{x.promocijaPostotakNaUplatu.slice(0, -4)}%</div> : x.jePrewager ? <div className="aktivnaPonudaIcon prewager">{!x.jeFreeSpinDepositPonuda ? x.promocijaPostotakNaUplatu.slice(0, -4) + '%' : ''}</div> : < div className="aktivnaPonudaIcon">{x.promocijaPostotakNaUplatu.slice(0, -4) + '%'}</div>}
                                        </div>
                                        <div className="aktivnaPonudaRight">
                                            <div className="naslov">{x.naziv}</div>
                                            <div className="opis">{x.opis}</div>
                                        </div>
                                    </div>
                                    <div className="aktivnaPonudaProgress">
                                        <div className="progress-bar">
                                            <div className="progress">
                                                <div className="bar" style={{ width: x.vrijediDoProgress + '%' }}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="aktivnaPonudaInfo">
                                        <p>Traje od {casino.utils.dateToDateTimeString(new Date(x.ponudaVrijediOd))}</p>
                                        <p >{x.ponudaVrijediDo ? 'do ' + casino.utils.dateToDateTimeString(new Date(x.ponudaVrijediDo)) : x.datumZavrsetka ? 'do ' + casino.utils.dateToDateTimeString(new Date(x.datumZavrsetka)) : ''}</p>
                                    </div>
                                    {x.jeFreeSpin && <div className="racunBonusiInfoBar">
                                        <p>Minimalna uplata: <b>{x.minDeposit} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                        <p>Vrijedi do: {x.ponudaVrijediDo ? <b>{casino.utils.dateToDateTimeString(new Date(x.ponudaVrijediDo))}</b> : x.datumZavrsetka ? <b>{casino.utils.dateToDateTimeString(new Date(x.datumZavrsetka))} </b> : < b > neograničeno</b>} </p>
                                        {x.active && (x.jePrewager || x.poker) && <button className="btn deaktiviraj" onClick={() => this.props.showPopUpFn(true, (x.jeFreeSpinDepositPonuda ? "prekiniPonudu" : "prekiniBonus"))}>DEAKTIVIRAJ</button>}
                                    </div>}
                                    {!x.jeFreeSpin && <> <div className="racunBonusiInfoBar">
                                        <p>Minimalna uplata: <b>{x.minDeposit} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                        <p>Maksimalni iznos bonusa: <b>{x.maxDeposit} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                    </div>
                                        <div className="racunBonusiInfoBar dupli">
                                            <p>Postotak na uplatu: <b>{x.promocijaPostotakNaUplatu}</b></p>
                                            <p>Vrijedi do: {x.ponudaVrijediDo ? <b>{casino.utils.dateToDateTimeString(new Date(x.ponudaVrijediDo))}</b> : x.datumZavrsetka ? <b>{casino.utils.dateToDateTimeString(new Date(x.datumZavrsetka))} </b> : <b> neograničeno</b>} </p>
                                            {x.active && (x.jePrewager || x.poker) && <button className="btn deaktiviraj" onClick={() => this.props.showPopUpFn(true, "prekiniPonudu")}>DEAKTIVIRAJ</button>}
                                        </div></>}
                                </div>
                            })}
                        </section>

                        {/*****************------------MOJA AKTIVNA FREE SPIN PROMOCIJA-------------******************/}
                        <section>
                            {this.props.user && !!this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.find(item => item.active && item.jeFreeSpin) &&
                                <div className="aktivnaPonudaSection" ><h3>Aktivni bonusi</h3>
                                    {this.props.user && !!this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.map(x => {
                                        if (x.active && x.jeFreeSpin)
                                            return <>
                                                <div className="aktivnaPonudaContainer">
                                                    <div className="aktivnaPonudaLeft">
                                                        <div className="aktivnaPonudaIcon fs"></div>
                                                    </div>
                                                    <div className="aktivnaPonudaRight">
                                                        <div className="naslov">{x.naziv}</div>
                                                        <div className="opis">{x.opis}</div>
                                                    </div>
                                                </div>
                                                <div className="racunBonusiInfoBar fs">
                                                    <p>Vrijedi do: <b>{x.datumZavrsetka ? casino.utils.dateToFullDateTimeString(new Date(x.datumZavrsetka)) : "neograničeno"}</b></p>
                                                    <p>Aktivno: <b>Da</b></p>
                                                </div>
                                            </>
                                    })}
                                </div>}
                        </section>

                        {/*****************------------MOJ AKTIVAN PREWAGER BONUS-------------******************/}
                        <section>
                            {this.props.user && !!this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.map(x => {
                                if (x.jePrewager && x.active)
                                    return <div key="aktivna-ponuda">
                                        <div className="aktivnaPonudaSection" key={x.id} >
                                            <h3>Moji aktivni bonusi</h3>
                                            <div className="aktivnaPonudaContainer">
                                                <div className="aktivnaPonudaLeft">
                                                    <div className="aktivnaPonudaIcon prewager"></div>
                                                </div>
                                                <div className="aktivnaPonudaRight">
                                                    <div className="naslov">{x.naziv}</div>
                                                    <div className="opis">{x.opis}</div>
                                                </div>
                                            </div>
                                            <div className="racunBonusiInfoBar fs">
                                                <p>Vrijedi do: <b>{x.datumZavrsetka ? casino.utils.dateToFullDateTimeString(new Date(x.datumZavrsetka)) : "neograničeno"}</b></p>
                                                <p>Aktivno: <b>Da</b></p>
                                            </div>
                                            <div className="racunBonusiInfoBar fs">
                                                <p>Iznos bonusa: <b>{x.iznos} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                                <p>Neodigrano: <b>{x.neodigrano} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                                {x.active && (x.jePrewager || x.poker) && <button className="btn deaktiviraj" onClick={() => this.props.showPopUpFn(true, "prekiniBonus")}>DEAKTIVIRAJ</button>}
                                            </div>
                                        </div>
                                    </div>
                            })}
                        </section>


                        {/*****************------------MOJ AKTIVAN POKER BONUS-------------******************/}
                        <section>
                            {this.props.user && !!this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.map(x => {
                                if (x.poker && x.active)
                                    return <div>
                                        <div className="aktivnaPonudaSection" key={x.id} >
                                            <h3>Moji aktivni bonusi</h3>
                                            <div className="aktivnaPonudaContainer">
                                                <div className="aktivnaPonudaLeft">
                                                    <div className="aktivnaPonudaIcon poker"></div>
                                                </div>
                                                <div className="aktivnaPonudaRight">
                                                    <div className="naslov">{x.naziv}</div>
                                                    <div className="opis">{x.opis}</div>
                                                </div>
                                            </div>
                                            <div className="racunBonusiInfoBar fs">
                                                <p>Iznos bonusa: <b>{x.iznos} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                                <p>Iznos preostalo: <b>{x.iznosPreostalo.slice(0, -3)} {x.valuta == 1 ? "kn" : "€"}</b></p>
                                                {x.active && (x.jePrewager || x.poker) && <button className="btn deaktiviraj" onClick={() => this.props.showPopUpFn(true, "prekiniBonus")}>DEAKTIVIRAJ</button>}
                                            </div>
                                        </div>
                                    </div>
                            })}
                        </section>



                        {/*************************------------PONUDA BONUSA------------*******************************/}

                        {this.state.samoZaMene && !!this.state.samoZaMene.length && <div className="zaMeneSection">
                            <div className="headerContent">
                                <div className="zaMeneLeft">
                                    <h1 className="text"><b>Ponuda bonusa</b></h1>
                                    <p className="podnaslov"><b>Odaberi jednu ponudu</b></p>
                                    <p className="ponudaTraje">Nove ponude traju do {casino.utils.dateToDateTimeString(new Date(this.state.samoZaMeneVrijediDo))}</p>
                                </div>
                                <div className="zaMeneRight">
                                    {this.state.disableBtn || !this.state.selectedPromotion && <button className="btn aktivirajPonudu disabled" disabled>PRIHVATI PONUDU</button>}
                                    {!this.state.disableBtn && this.state.selectedPromotion && <button className="btn aktivirajPonudu" onClick={() => this.showPopUp(this.state.selectedPromotion)}>PRIHVATI PONUDU</button>}
                                </div>
                            </div>
                            <table>
                                <tbody>
                                    {!!this.state.samoZaMene.length && this.state.samoZaMene.map((x, index) => {
                                        return <tr key={'promotion-' + index} className="bonuses">
                                            <td className="ikonaContainer">{x.freespinBrojSpinova > 0 ? <div className="ikonaZaMene freeSpin"></div> : x.jePrewager ? <div className="ikonaZaMene prewager" /> : x.poker ? < div className="ikonaZaMene poker" /> : x.jePonudaBonusTransakcije ? < div className="ikonaZaMene bonus" /> : < div className="ikonaZaMene" />}</td>
                                            <td className="tekstContainer"><h3>{x.naziv}</h3><p>{x.opis}</p></td>
                                            <td className="inputContainer">
                                                <div className="racunBonusiCheckboxContainer">
                                                    <input type="radio" onClick={() => this.selectPromotion(x)} name="myRadioField" id="myRadioId" className="racunBonusiCheckbox" disabled={this.state.promotions.availableItems.length > 0 || this.props.user.promocije.availableItems.length > 0 ? true : false} />
                                                </div>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>}


                        {/*************************-----------NEMA-PONUDA BONUSA------------*******************************/}

                        {this.state.samoZaMene && !this.state.samoZaMene.length &&
                            <div className="nemaBonusaSection">
                                <h3>Ponuda bonusa</h3>
                                <div className="nemaBonusaContainer">
                                    <div className="nemaBonusaLeft">
                                        <div className="nemaBonusaIcon">
                                        </div>
                                    </div>
                                    <div className="nemaBonusaCenter">
                                        <p>
                                            Trenutno nema novih ponuda bonusa! Obavijestit ćemo
                                            te na vrijeme kada nove ponude bonusa budu aktivne!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/*************************-----------ARHIVA BONUSA-------------*******************************/}

                        {this.state.archive !== undefined && this.state.archive.length > 0 ? <div className="arhivaBonusaSection">
                            <h3>Arhiva bonusa</h3>
                            {this.state.archive && this.state.archive.map((x, i) => {
                                if (x.active && x.jeFreeSpin)
                                    return;

                                return <div className="arhivaBonusaContainer" key={x.id + i} >
                                    <div className="arhivaLeft">
                                        <div className="arhivaNaslov"><b>{x.naziv}</b></div>
                                    </div>
                                    <div className="arhivaCenter">
                                        <div className="arhivaNaslov">Iznos bonusa</div>
                                        <div className={x.jeIspunjena ? "arhivaIznos green" : "arhivaIznos"}><b>{casino.utils.numberWithCurrencyFromated(x.iznos, x.valuta)}</b></div>
                                    </div>
                                    <div className="arhivaRight">
                                        <div className="arhivaNaslov">Ispunjeno</div>
                                        <div className="arhivaIspunjeno">{x.jeIspunjena ? <div className="flex"><b>DA</b><span className="arhivaIconCheck"></span></div> : <div className="flex"><b>NE</b><span className="arhivaIconMinus"></span></div>}</div>
                                    </div>
                                    <div className="text-center">
                                        {x.active && (x.jePrewager || x.poker) && <button className="red btn small fill" onClick={() => this.props.showPopUpFn(true, "prekiniBonus")}>Prekini</button>}
                                    </div>
                                </div>
                            })}
                        </div> : ''}
                    </div>
                </div>
            </div>

        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}
            </div>
        }


    }
};
